import { whenDocumentReady } from '../../../../../paws/assets/frontend/js/helper/documentready';

whenDocumentReady(initModule);
function initModule() {
    let lsCat = localStorage.getItem('jobs_cat');
    let lsReg = localStorage.getItem('jobs_reg');
    if (lsCat !== null && lsCat.length > 0) {
        document.querySelector('#jobcategory').querySelector('[value="' + lsCat + '"]').setAttribute("selected", "selected");
    }
    if (lsReg !== null && lsReg.length > 0) {
        document.querySelector('#jobregion').querySelector('[value="' + lsReg + '"]').setAttribute("selected", "selected");
    }
    jobsFilter();

    document.addEventListener('input', function (event) {
        // Only run on our select menu
        if (event.target.id !== 'jobcategory' && event.target.id !== 'jobregion') return;

        jobsFilter();
    }, false);
}

function jobsFilter() {
    let cat = document.querySelector('#jobcategory').value;
    let reg = document.querySelector('#jobregion').value;
    if (cat !== null) {
        localStorage.setItem('jobs_cat', cat);
    }
    if (reg !== null) {
        localStorage.setItem('jobs_reg', reg);
    }

    let query = [];
    if (cat !== null && cat.length > 0) {
        query.push(cat);
    }
    if (reg !== null && reg.length > 0) {
        query.push(reg);
    }

    if (query.length > 0) {
        // filter
        let items = document.querySelector('.noss_jobs.default.noss-customfilter').querySelector('.items').querySelectorAll('.item');
        let foundItems = false;
        if (items) {
            for (let k = 0; k < items.length; ++k) {
                let isValid = true;
                for (let i = 0; i < query.length; i++) {
                    if (!items[k].classList.contains(query[i])) {
                        isValid = false;
                    }
                }

                if (isValid) {
                    foundItems = true;
                    items[k].classList.remove('filtered');
                }
                else {
                    items[k].classList.add('filtered');
                }
            }
        }

        if (!foundItems) {
            document.querySelector('.noss_jobs.default.noss-customfilter').querySelector('.items').querySelector('.notfound').classList.add('active');
        }
        else {
            document.querySelector('.noss_jobs.default.noss-customfilter').querySelector('.items').querySelector('.notfound').classList.remove('active');
        }
    }
    else {
        // reset
        let items = document.querySelector('.noss_jobs.default.noss-customfilter').querySelector('.items').querySelectorAll('.item.filtered');
        for (let k = 0; k < items.length; ++k) {
            items[k].classList.remove('filtered');
        }
    }
}
